<template>
  <v-dialog
    v-model="open"
    max-width="700px"
    scollable
    content-class="dialog-top-right"
  >
    <template #activator="{ props }">
      <slot :props="props"></slot>
    </template>

    <v-card flat>
      <v-toolbar dense flat dark color="primary">
        <v-toolbar-title><v-icon> mdi-help-circle-outline</v-icon>&nbsp;&nbsp;<b>Invite members</b></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn variant="text" icon color="grey" @click="open = false">
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-1">
        <h3>Add people by email</h3>
        Type or paste an email address into the field, press Enter, and click Invite.
        Everyone you invite gets an email — people who don't have a Qlerify account yet
        are invited to create one.
        <br><br>
        <b>Seats:</b>
        Invited people need a seat on your plan, or a subscription of their own, to open the project.
        If someone needs a seat, you'll see the cost and can confirm before anything is charged.
        <br><br>
        <b>Who can invite:</b>
        Anyone can invite someone who already has access. Buying a seat is done by the person who
        pays for the plan, so an invitee who needs one has to be added by them.
        <br><br>
        <b>Note:</b>
        Access is granted to the entire project.
        Invited people will be able to see all workflows within the project.
        <br><br>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue'

const open = ref(false)
</script>
